export const isAlertEnabled = state => state.alert;



// WEBPACK FOOTER //
// ./src/store/reducers/alert/selectors.js